import { Routes } from 'app/services/routeService/routeService'
import { AccessType } from 'app/auth/accessControlService'
import Group from './Group'
import GroupPage from './GroupPage'
import GroupDetails from './GroupDetails'

export default {
  settings: {
    layout: {
      config: {
        navbar: {
          display: true,
        },
        toolbar: {
          display: true,
        },
        leftSidePanel: {
          display: true,
        },
      },
    },
  },
  routes: [
    {
      path: Routes.groups(),
      accesses: [AccessType.NOTIFICATION_VIEW_OWNED],
      component: Group,
      routes: [
        {
          exact: true,
          path: Routes.groups(),
          component: GroupPage,
        },
        {
          exact: true,
          path: Routes.groupsDetail(),
          component: GroupDetails,
        },
      ],
    },
  ],
}
